import React from "react";
import { Link } from "react-router-dom";
import { CONTACT, whatsappUrl } from "../../lib/email";

const StickyCTA = () => {
  return (
    <div className="fixed bottom-4 left-0 right-0 z-50 px-4 lg:hidden">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 rounded-2xl border border-white/10 bg-black/60 p-3 backdrop-blur-xl shadow-[0_18px_60px_rgba(0,0,0,0.55)]">
        <a
          href={whatsappUrl("Hello glowLAWNS®, I would like to check availability and pricing.")}
          target="_blank"
          rel="noreferrer"
          className="flex-1 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-center text-sm font-semibold text-white/90 hover:bg-white/10 transition"
          aria-label={`Chat on WhatsApp ${CONTACT.whatsappDisplay}`}
        >
          WhatsApp
        </a>
        <Link
          to="/contact"
          className="flex-1 rounded-xl bg-[#C9A227] px-4 py-3 text-center text-sm font-semibold text-[#111] shadow-[0_12px_28px_rgba(0,0,0,0.35)]"
        >
          Book Now
        </Link>
      </div>
    </div>
  );
};

export default StickyCTA;
